import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Button, Checkbox, Chip, Divider, Grid, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import { ReactComponent as Downarrow } from '../../assets/images/downArrow.svg';
import { InputBox, MuiButton, MuiStack } from "../../components";
import { MuiSelectComponent } from "../../components/atoms/muiSelectComponent";
import { gray } from "../../theme/palette";
import { DownloadIconSVG } from "../spareParts/purchaseRequistion/assets/customIcons";
export var AlertDetailsRecall = function (props) {
    var _a = useState(false), isExpand = _a[0], setIsExpand = _a[1];
    var _b = useState(false), isExpandParent = _b[0], setIsExpandParent = _b[1];
    var _c = useState(false), drawerOpen = _c[0], setDrawerOpen = _c[1];
    var _d = useState(null), selectedReason = _d[0], setSelectedReason = _d[1];
    var _e = useState({}), moreView = _e[0], setIsMoreView = _e[1];
    var _f = useState({
        1: true,
        2: true,
        3: true
    }), expandedItems = _f[0], setExpandedItems = _f[1];
    var cancellationReasons = [{
            DisplayName: "Reason 1",
            RepeatRevisitReasonId: "1"
        }, {
            DisplayName: "Reason 2",
            RepeatRevisitReasonId: "2"
        }, {
            DisplayName: "Reason 3",
            RepeatRevisitReasonId: "3"
        }, {
            DisplayName: "Reason 4",
            RepeatRevisitReasonId: "4"
        }];
    var recallData = [{
            id: 1,
            recallName: "Fuel tank inspection and correcting hook position",
            recallNumber: "0110032056378932",
            recallType: "Safety (Mandatory)",
            actionType: "To be checked & corrected",
            moreList: [{
                    id: 101,
                    partName: "Fuel Cap",
                    partNumber: "FC-2025",
                    qty: 1,
                    action: "Replace if damaged"
                }, {
                    id: 102,
                    partName: "Fuel Pipe",
                    partNumber: "FP-3056",
                    qty: 1,
                    action: "Inspect & clean"
                }, {
                    id: 103,
                    partName: "Tank Seal",
                    partNumber: "TS-4521",
                    qty: 1,
                    action: "Ensure proper fit"
                }, {
                    id: 104,
                    partName: "Fuel Cap",
                    partNumber: "FC-2025",
                    qty: 1,
                    action: "Replace if damaged"
                }, {
                    id: 105,
                    partName: "Fuel Pipe",
                    partNumber: "FP-3056",
                    qty: 1,
                    action: "Inspect & clean"
                }, {
                    id: 106,
                    partName: "Tank Seal",
                    partNumber: "TS-4521",
                    qty: 1,
                    action: "Ensure proper fit"
                }]
        }, {
            id: 2,
            recallName: "Recall 2",
            recallNumber: "0110032056378932",
            recallType: "Safety (Mandatory)",
            actionType: "To be checked & corrected",
            moreList: [{
                    id: 201,
                    partName: "Brake Pad",
                    partNumber: "BP-7834",
                    qty: 2,
                    action: "Replace if worn"
                }]
        }, {
            id: 3,
            recallName: "Recall 3",
            recallNumber: "0110032056378932",
            recallType: "Safety (Mandatory)",
            actionType: "To be checked & corrected",
            moreList: [{
                    id: 301,
                    partName: "Clutch Cable",
                    partNumber: "CC-6789",
                    qty: 1,
                    action: "Adjust as needed"
                }, {
                    id: 302,
                    partName: "Clutch Lever",
                    partNumber: "CL-5432",
                    qty: 1,
                    action: "Replace if broken"
                }, {
                    id: 303,
                    partName: "Clutch Spring",
                    partNumber: "CS-1123",
                    qty: 2,
                    action: "Check & replace if weak"
                }]
        }];
    var handleCheckboxChange = function (id) {
        setExpandedItems(function (prevState) {
            var _a;
            return _objectSpread(_objectSpread({}, prevState), {}, (_a = {},
                _a[id] = !prevState[id],
                _a));
        });
    };
    var toggleExpand = function (id) {
        setIsMoreView(function (prev) {
            var _a;
            return _objectSpread(_objectSpread({}, prev), {}, (_a = {},
                _a[id] = !prev[id],
                _a));
        });
    };
    var handleReasonChange = function (event) {
        setSelectedReason(event.target.value);
    };
    var handleOpen = function () {
        setDrawerOpen(true);
    };
    var handleClose = function () {
        setDrawerOpen(false);
    };
    return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        gap: '16px'
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            height: '1px',
            bgcolor: {
                gray: gray
            },
            width: '100%'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        gap: '16px',
        flexDirection: 'column'
    }, recallData.map(function (item) {
        var _item$moreList;
        return /*#__PURE__*/ React.createElement(Grid, {
            sx: {
                border: '1px solid',
                borderRadius: "8px",
                borderColor: "".concat(expandedItems[item.id] ? 'secondary.200' : 'error.500')
            },
            gap: '8px'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            minHeight: '46px',
            bgcolor: expandedItems[item.id] ? 'background.secondary' : 'error.50',
            sx: {
                borderRadius: '8px 8px 0px 0px',
                padding: '12px 16px'
            },
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(Stack, {
            flexDirection: 'row',
            gap: '12px',
            alignItems: 'start'
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            checked: expandedItems[item.id],
            onChange: function () { return handleCheckboxChange(item.id); },
            sx: {
                padding: 0,
                "&:hover": {
                    bgcolor: 'transparent'
                }
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                flexDirection: 'column'
            },
            gap: '2px'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, t(item === null || item === void 0 ? void 0 : item.recallName)), /*#__PURE__*/ React.createElement(Stack, {
            direction: 'row',
            gap: '10px'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: 'text.tertiary'
        }, t(item === null || item === void 0 ? void 0 : item.recallNumber)), /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: 'medium',
            fontSize: 'sm',
            color: 'text.secondary'
        }, t('Optional'))))), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Button, {
            variant: "text",
            color: "primary",
            endIcon: /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                height: 16,
                width: 16
            })
        }, "SOP"))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                paddingInline: '16px'
            },
            height: 'auto',
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(Box, {
            padding: '12px',
            display: 'flex',
            gap: '12px'
        }, /*#__PURE__*/ React.createElement(Typography, {
            color: 'text.secondary',
            fontSize: 'sm',
            fontWeight: 'medium'
        }, "Description  :"), /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'sm',
            fontWeight: 'medium'
        }, "To be checked & corrected")), /*#__PURE__*/ React.createElement(Stack, {
            gap: '10px'
        }, !expandedItems[item.id] && /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'column'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'sm',
            fontWeight: 'medium',
            paddingY: 1,
            color: 'text.secondary'
        }, t("Rejection reason*")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            id: "repeatRecall",
            options: cancellationReasons,
            fullWidth: true,
            name: "repeatRecall",
            displayExpr: "DisplayName",
            valueExpr: "RepeatReCalllReasonId",
            value: selectedReason,
            placeholder: t('Select cancellation reason'),
            onChange: handleReasonChange
        })), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            sm: 12,
            pt: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'sm',
            fontWeight: 'medium',
            paddingY: 1,
            color: 'text.secondary'
        }, t("Remarks")), /*#__PURE__*/ React.createElement(InputBox, {
            tabIndex: 1,
            onChange: function (event) { },
            placeholder: t('Enter Remarks'),
            fullWidth: true,
            size: "small",
            name: "remarks",
            multiline: true,
            rows: 3,
            sx: {
                "& .MuiInputBase-root.Mui-disabled": {
                    backgroundColor: "white",
                    borderRadius: '8px'
                }
            },
            id: "remarks"
        }))), (item === null || item === void 0 ? void 0 : item.moreList) && /*#__PURE__*/ React.createElement(Box, {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            sx: {
                overflow: 'hidden',
                maxHeight: moreView[item.id] ? '500px' : '0px',
                opacity: moreView[item.id] ? 1 : 0,
                transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out'
            }
        }, item === null || item === void 0 || (_item$moreList = item.moreList) === null || _item$moreList === void 0 ? void 0 : _item$moreList.map(function (part) { /*#__PURE__*/ return React.createElement(Stack, {
            key: part.id,
            minHeight: '116px',
            flexDirection: 'row',
            justifyContent: 'space-between',
            sx: {
                borderRadius: '8px',
                padding: '12px',
                border: '1px solid',
                borderColor: 'secondary.200'
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            width: '90%'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontWeight: 'medium'
        }, part.partName), /*#__PURE__*/ React.createElement(Typography, {
            color: 'text.tertiary',
            fontSize: 'sm'
        }, part.partNumber), /*#__PURE__*/ React.createElement(Box, {
            display: 'flex'
        }, /*#__PURE__*/ React.createElement(Typography, {
            width: '45%',
            fontSize: 'sm',
            fontWeight: 'bold',
            color: 'text.tertiary'
        }, "Action required:"), /*#__PURE__*/ React.createElement(Typography, {
            width: '55%',
            fontSize: 'sm',
            fontWeight: 'medium'
        }, part.action)), /*#__PURE__*/ React.createElement(Box, {
            display: 'flex'
        }, /*#__PURE__*/ React.createElement(Typography, {
            width: '45%',
            fontSize: 'sm',
            fontWeight: 'bold',
            color: 'text.tertiary'
        }, "Qty:"), /*#__PURE__*/ React.createElement(Typography, {
            width: '55%',
            fontSize: 'sm',
            fontWeight: 'medium'
        }, part.qty))), /*#__PURE__*/ React.createElement(Chip, {
            variant: "filled",
            size: "small",
            color: "secondary",
            label: "P"
        })); }))), /*#__PURE__*/ React.createElement(Box, {
            padding: '12px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'sm',
            color: 'text.tertiary'
        }, "Parts ", /*#__PURE__*/ React.createElement("span", {
            style: {
                color: "text.primary"
            }
        }, "02"), " | Labours ", /*#__PURE__*/ React.createElement("span", {
            style: {
                color: "text.primary"
            }
        }, "01")), /*#__PURE__*/ React.createElement(Button, {
            variant: "text",
            color: "secondary",
            endIcon: /*#__PURE__*/ React.createElement(Downarrow, {
                color: "text.secondary"
            }),
            onClick: function () { return toggleExpand(item === null || item === void 0 ? void 0 : item.id); }
        }, moreView[item.id] ? 'Hide' : 'View more'))));
    })), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            height: '1px',
            bgcolor: {
                gray: gray
            },
            width: '100%'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'end'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        size: "medium",
        name: "Save"
    }))));
};
